import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

// Alertify
import * as alertify from '../../../components/Alerts/lib/alertify';

// Api
import signInApi from '../../api/signIn.api.auth';

// Auth
import authCallbackRoute from '../../pages/AuthCallbackPage/route';
import performAuthRoute from '../../pages/PerformAuthPage/route';

// Components
import FullScreenLoader from '../../../layout/components/FullScreenLoader/FullScreenLoader';
import SignIn from '../../components/SignIn/SignIn';

// Context
import { useAuth } from '../../../contexts';

// Events
import forceAuthorizationEvent from '../../events/forceAuthorization.event.auth';

// Hooks
import { useSubscription } from '../../../hooks';

const AuthContainer = ({ children, window: windowProp = window }) => {
  const { initialized, user, init } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    init();
  }, [init]);

  const reset = useCallback(() => {
    setError(true);
  }, []);

  useSubscription([forceAuthorizationEvent.subscribe(reset)]);

  const isOnAuthPage = () => {
    return [authCallbackRoute(), performAuthRoute()].includes(
      windowProp.location.pathname
    );
  };

  const signIn = async () => {
    setLoading(true);
    setError(null);
    try {
      const { redirectUrl } = await signInApi({
        redirectTo: windowProp.location.origin,
      });
      windowProp.location.href = redirectUrl;
    } catch (error) {
      alertify.error('Something went wrong. Refresh your browser.');
      setLoading(false);
    }
  };

  return !!user || isOnAuthPage() ? (
    children
  ) : loading || !initialized ? (
    <FullScreenLoader />
  ) : (
    <SignIn error={error} onSignIn={signIn} />
  );
};

AuthContainer.propTypes = {
  children: PropTypes.node,
  window: PropTypes.object,
};

export default AuthContainer;
